var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProjects = function SvgIconProjects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_projects_svg2__a",
    x1: -18.15,
    x2: 384.02,
    y1: 424.93,
    y2: 36.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_projects_svg2__a",
    id: "icon_projects_svg2__b",
    x1: -106.47,
    x2: 295.71,
    y1: 333.44,
    y2: -54.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_projects_svg2__a",
    id: "icon_projects_svg2__c",
    x1: -41.65,
    x2: 360.52,
    y1: 400.59,
    y2: 12.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_projects_svg2__a",
    id: "icon_projects_svg2__d",
    x1: -41.65,
    x2: 360.52,
    y1: 400.59,
    y2: 12.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_projects_svg2__a",
    id: "icon_projects_svg2__e",
    x1: -4.51,
    x2: 397.66,
    y1: 439.06,
    y2: 50.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_projects_svg2__a",
    id: "icon_projects_svg2__f",
    x1: 39.13,
    x2: 441.3,
    y1: 484.28,
    y2: 96.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_projects_svg2__a",
    id: "icon_projects_svg2__g",
    x1: 43.95,
    x2: 446.12,
    y1: 489.27,
    y2: 101.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_projects_svg2__a",
    id: "icon_projects_svg2__h",
    x1: 27.18,
    x2: 429.36,
    y1: 471.9,
    y2: 83.71
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_projects_svg2__a",
    id: "icon_projects_svg2__i",
    x1: 70.83,
    x2: 473,
    y1: 517.12,
    y2: 128.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_projects_svg2__a",
    id: "icon_projects_svg2__j",
    x1: 75.64,
    x2: 477.82,
    y1: 522.11,
    y2: 133.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_projects_svg2__a",
    id: "icon_projects_svg2__k",
    x1: 9.76,
    x2: 411.93,
    y1: 453.85,
    y2: 65.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_projects_svg2__a",
    id: "icon_projects_svg2__l",
    x1: 84.61,
    x2: 486.79,
    y1: 531.4,
    y2: 143.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_projects_svg2__a",
    id: "icon_projects_svg2__m",
    x1: 155.16,
    x2: 557.33,
    y1: 604.48,
    y2: 216.29
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_projects_svg2__a",
    id: "icon_projects_svg2__n",
    x1: 117.62,
    x2: 519.79,
    y1: 565.59,
    y2: 177.4
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M113.68 488.19H17.8c-3.31 0-6.01-2.7-6.01-6.01V205.31c0-3.25-2.64-5.89-5.89-5.89s-5.89 2.64-5.89 5.89v276.87c0 9.81 7.98 17.8 17.8 17.8h95.88c3.25 0 5.89-2.64 5.89-5.89s-2.64-5.89-5.89-5.89Z",
    style: {
      fill: "url(#icon_projects_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89 176.73c3.26 0 5.89-2.64 5.89-5.89V79.33c0-3.31 2.7-6.01 6.01-6.01h307.47c3.25 0 5.89-2.64 5.89-5.89s-2.64-5.89-5.89-5.89H17.8C7.99 61.54 0 69.52 0 79.34v91.51c0 3.25 2.64 5.89 5.89 5.89Z",
    style: {
      fill: "url(#icon_projects_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.73 175.58c-23.27 0-42.21 18.93-42.21 42.21S124.45 260 147.73 260s42.21-18.93 42.21-42.21-18.93-42.21-42.21-42.21m0 72.63c-16.77 0-30.42-13.65-30.42-30.42s13.65-30.42 30.42-30.42 30.42 13.65 30.42 30.42-13.65 30.42-30.42 30.42",
    style: {
      fill: "url(#icon_projects_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.69 166.15-12.26-21.24c-3.72-6.45-11.47-9.18-18.42-6.5l-28.06 10.84a87.2 87.2 0 0 0-23.47-13.58l-4.64-29.7c-1.15-7.36-7.39-12.7-14.84-12.7h-24.53c-7.45 0-13.69 5.34-14.84 12.7l-4.64 29.7a87.2 87.2 0 0 0-23.47 13.58l-28.06-10.84c-6.95-2.68-14.69.05-18.42 6.5l-12.27 21.24c-3.72 6.45-2.22 14.53 3.58 19.2l23.41 18.88c-.69 4.48-1.04 9.02-1.04 13.56s.35 9.08 1.04 13.56l-23.41 18.88c-5.8 4.68-7.3 12.75-3.58 19.2l12.26 21.24c3.72 6.45 11.47 9.19 18.42 6.5l28.06-10.84a87.4 87.4 0 0 0 23.47 13.58l4.64 29.7c1.15 7.36 7.39 12.7 14.84 12.7h24.53c7.45 0 13.69-5.34 14.84-12.7l4.64-29.7a87.2 87.2 0 0 0 23.47-13.58L231 297.17c6.95 2.69 14.69-.05 18.42-6.5l12.26-21.24c3.72-6.45 2.22-14.52-3.58-19.2l-23.41-18.88c.69-4.48 1.04-9.03 1.04-13.56s-.35-9.08-1.04-13.56l23.41-18.88c5.8-4.68 7.3-12.75 3.58-19.2Zm-10.98 10.03-26.12 21.06a5.89 5.89 0 0 0-2.08 5.73 76.7 76.7 0 0 1-.01 29.64c-.42 2.15.38 4.35 2.08 5.73l26.12 21.06a3.21 3.21 0 0 1 .77 4.13l-12.26 21.24a3.21 3.21 0 0 1-3.96 1.4l-31.31-12.09a5.91 5.91 0 0 0-6.01 1.06c-7.56 6.62-16.19 11.61-25.65 14.83a5.91 5.91 0 0 0-3.93 4.67l-5.18 33.14a3.22 3.22 0 0 1-3.19 2.73h-24.53c-1.6 0-2.94-1.15-3.19-2.73l-5.18-33.14a5.89 5.89 0 0 0-3.93-4.67c-9.46-3.22-18.09-8.21-25.65-14.83a5.88 5.88 0 0 0-6.01-1.06l-31.31 12.09c-1.49.58-3.16-.01-3.96-1.4l-12.26-21.24c-.8-1.39-.48-3.12.77-4.13l26.12-21.06a5.89 5.89 0 0 0 2.08-5.73c-.96-4.86-1.44-9.85-1.44-14.82s.49-9.96 1.44-14.82c.42-2.15-.38-4.35-2.08-5.73l-26.12-21.06a3.21 3.21 0 0 1-.77-4.13l12.27-21.24c.8-1.39 2.47-1.98 3.96-1.4L91.5 161.5c2.04.79 4.36.38 6.01-1.07 7.56-6.62 16.19-11.61 25.65-14.83a5.91 5.91 0 0 0 3.93-4.67l5.18-33.14a3.22 3.22 0 0 1 3.19-2.73h24.53c1.6 0 2.94 1.15 3.19 2.73l5.18 33.14a5.89 5.89 0 0 0 3.93 4.67c9.46 3.22 18.09 8.21 25.65 14.83a5.9 5.9 0 0 0 6.01 1.06l31.31-12.09c1.49-.58 3.16.01 3.96 1.4l12.26 21.24c.8 1.39.48 3.12-.77 4.13Z",
    style: {
      fill: "url(#icon_projects_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3 375.1c0-7.63-6.21-13.83-13.83-13.83H45.59c-7.63 0-13.83 6.2-13.83 13.83v15.88c0 7.63 6.21 13.83 13.83 13.83h15.88c7.63 0 13.83-6.2 13.83-13.83zm-11.79 15.88c0 1.13-.92 2.05-2.05 2.05H45.58c-1.13 0-2.04-.92-2.04-2.04v-15.88c0-1.13.92-2.04 2.04-2.04h15.88c1.13 0 2.04.92 2.04 2.04v15.88Z",
    style: {
      fill: "url(#icon_projects_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.76 361.27H101.15c-3.25 0-5.89 2.64-5.89 5.89s2.64 5.89 5.89 5.89h118.61c3.25 0 5.89-2.64 5.89-5.89s-2.64-5.89-5.89-5.89",
    style: {
      fill: "url(#icon_projects_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.16 404.81h72.8c3.25 0 5.89-2.64 5.89-5.89s-2.64-5.89-5.89-5.89h-72.8c-3.25 0-5.89 2.64-5.89 5.89s2.64 5.89 5.89 5.89",
    style: {
      fill: "url(#icon_projects_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.59 424.7c-7.63 0-13.83 6.2-13.83 13.83v15.88c0 7.63 6.21 13.83 13.83 13.83h15.88c7.63 0 13.83-6.2 13.83-13.83v-15.88c0-7.63-6.21-13.83-13.83-13.83zm17.92 13.84v15.88c0 1.13-.92 2.05-2.05 2.05H45.58c-1.13 0-2.04-.92-2.04-2.04v-15.88c0-1.13.92-2.04 2.04-2.04h15.88c1.13 0 2.04.92 2.04 2.04Z",
    style: {
      fill: "url(#icon_projects_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.66 430.6c0-3.25-2.64-5.89-5.89-5.89H101.16c-3.25 0-5.89 2.64-5.89 5.89s2.64 5.89 5.89 5.89h118.61c3.25 0 5.89-2.64 5.89-5.89",
    style: {
      fill: "url(#icon_projects_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.16 456.46c-3.25 0-5.89 2.64-5.89 5.89s2.64 5.89 5.89 5.89h72.8c3.25 0 5.89-2.64 5.89-5.89s-2.64-5.89-5.89-5.89z",
    style: {
      fill: "url(#icon_projects_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.94 111.14c0-9.82-7.99-17.8-17.8-17.8h-67.66c-9.82 0-17.8 7.99-17.8 17.8v39.69c0 9.82 7.99 17.8 17.8 17.8h27.94v34.42l-9.79-9.78c-2.3-2.3-6.03-2.3-8.34 0-2.3 2.3-2.3 6.03 0 8.34l19.84 19.84c.28.28.58.53.91.74.02.01.04.03.06.04.3.2.62.36.96.5.02.01.05.02.08.03q.495.195 1.02.3h.06c.35.07.71.1 1.08.1s.73-.04 1.08-.1h.06c.35-.07.7-.17 1.02-.3.03 0 .05-.02.08-.03a7 7 0 0 0 1.02-.54c.33-.22.63-.47.91-.74l19.84-19.84c2.3-2.3 2.3-6.03 0-8.34s-6.03-2.3-8.34 0l-9.78 9.78v-34.42h27.94c9.82 0 17.8-7.99 17.8-17.8v-39.69Zm-11.79 39.7c0 3.32-2.7 6.01-6.01 6.01h-67.66c-3.32 0-6.01-2.7-6.01-6.01v-39.69c0-3.32 2.7-6.01 6.01-6.01h67.66c3.32 0 6.01 2.7 6.01 6.01z",
    style: {
      fill: "url(#icon_projects_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.94 260.95c0-9.82-7.99-17.8-17.8-17.8h-67.66c-9.82 0-17.8 7.99-17.8 17.8v39.69c0 9.82 7.99 17.8 17.8 17.8h27.94v34.42l-9.79-9.79c-2.3-2.3-6.03-2.3-8.34 0s-2.3 6.03 0 8.34l19.85 19.85c.27.27.58.52.9.74.02.01.05.03.07.04.3.19.62.36.95.5.03.01.05.02.08.03q.495.195 1.02.3h.06c.35.07.71.1 1.08.1s.73-.04 1.08-.1h.06c.35-.07.7-.17 1.02-.3.02 0 .05-.02.07-.03.34-.14.66-.31.96-.5a.2.2 0 0 0 .06-.04c.33-.22.64-.47.91-.75l19.84-19.84a5.89 5.89 0 0 0-8.33-8.33l-9.78 9.78v-34.42h27.94c9.82 0 17.8-7.99 17.8-17.8v-39.69Zm-11.79 39.69c0 3.32-2.7 6.01-6.01 6.01h-67.66c-3.32 0-6.01-2.7-6.01-6.01v-39.69c0-3.32 2.7-6.01 6.01-6.01h67.66c3.32 0 6.01 2.7 6.01 6.01z",
    style: {
      fill: "url(#icon_projects_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.13 392.95h-67.66c-9.82 0-17.8 7.99-17.8 17.8v39.69c0 9.82 7.99 17.8 17.8 17.8h67.66c9.82 0 17.8-7.99 17.8-17.8v-39.69c0-9.82-7.99-17.8-17.8-17.8m6.02 57.49c0 3.32-2.7 6.01-6.01 6.01h-67.66c-3.32 0-6.01-2.7-6.01-6.01v-39.69c0-3.32 2.7-6.01 6.01-6.01h67.66c3.32 0 6.01 2.7 6.01 6.01z",
    style: {
      fill: "url(#icon_projects_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 446.47V54.37c0-14.4-5.92-28.55-16.25-38.8C473.63 5.52 460.4 0 446.46 0h-.37a53.26 53.26 0 0 0-29.65 9.21 21.77 21.77 0 0 0-9.54 18.02v34.29h-47.16c-3.25 0-5.89 2.64-5.89 5.89s2.64 5.89 5.89 5.89h47.16v312.2c0 6.91 3.17 13.25 8.7 17.4 5.54 4.15 12.53 5.43 19.18 3.49 3.78-1.1 7.72-1.66 11.69-1.66 23.01 0 41.74 18.72 41.74 41.74 0 23.01-18.72 41.74-41.74 41.74H148.16c-3.25 0-5.89 2.63-5.89 5.88s2.64 5.89 5.89 5.89h298.31c29.51 0 53.52-24 53.53-53.51m-53.52-53.52c-5.09 0-10.14.72-14.99 2.13-3.06.89-6.27.31-8.81-1.6a9.89 9.89 0 0 1-3.98-7.97V27.23c0-3.32 1.64-6.41 4.38-8.27 6.83-4.64 14.82-7.12 23.11-7.18 10.95-.1 21.31 4.24 29.27 12.14 8.11 8.06 12.77 19.15 12.77 30.44v358.63c-9.82-12.22-24.88-20.05-41.74-20.05Z",
    style: {
      fill: "url(#icon_projects_svg2__n)"
    }
  }));
};
export default SvgIconProjects;